import { render, staticRenderFns } from "./view.vue?vue&type=template&id=4956e5c8"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
import style0 from "./view.vue?vue&type=style&index=0&id=4956e5c8&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4956e5c8')) {
      api.createRecord('4956e5c8', component.options)
    } else {
      api.reload('4956e5c8', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=4956e5c8", function () {
      api.rerender('4956e5c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/preempt/view.vue"
export default component.exports